// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Particle_zIndex from "../../particle/Particle_zIndex.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";

var rulesContainer = Particle_Screen_Ds.make(undefined, undefined, [CssJs.overflow(CssJs.visible)], undefined, undefined, [CssJs.overflow("hidden")]);

var rulesChildsItems = Particle_Screen_Ds.make(undefined, undefined, [
      CssJs.selector("li:last-child a", [CssJs.borderStyle("none")]),
      CssJs.position("absolute"),
      Particle_zIndex.Particle_zIndex_Css.toCss({
            TAG: /* Above */1,
            _0: /* Cta */4
          }),
      CssJs.top({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.right("zero"),
      CssJs.unsafe("min-width", "max-content")
    ], undefined, undefined, [CssJs.borderStyle("none")]);

var searchZIndexRule = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Behind */2,
      _0: /* Header */7
    });

var rulesSearchForm = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.top({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.left("zero"),
      CssJs.right("zero"),
      searchZIndexRule
    ]);

export {
  rulesContainer ,
  rulesChildsItems ,
  searchZIndexRule ,
  rulesSearchForm ,
}
/* rulesContainer Not a pure module */
